import { logEvent } from 'firebase/analytics';
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { FirebaseContext } from './context';

export const Footer = () => {
    const { analytics } = useContext(FirebaseContext);
    const navigate = useNavigate();
    return <div className='bg-gray-200 px-10'>
        <div className='text-center py-10'>
            <p className="text-4xl mb-3 cursor-pointer" onClick={() => navigate('/')}>Дорогой добра</p>
            <p className="mb-5 text-gray-500">Владивосток, Бульварная 15</p>
            <div className='flex gap-5 text-[#01487C] fa-3x justify-center mb-5'>
                <i className="fa-brands fa-instagram cursor-pointer" onClick={() => {
                    logEvent(analytics!, 'social_redirect', {
                        service: 'instagram'
                    });
                    window.location.href = 'https://www.instagram.com/kaleidoscope_ddo/';
                }}></i>
                <i className="fa-brands fa-facebook cursor-pointer" onClick={() => {
                    logEvent(analytics!, 'social_redirect', {
                        service: 'facebook'
                    });
                    window.location.href = 'https://www.facebook.com/kaleidoscope_ddo-105990414456061';
                }}></i>
                <i className="fa-brands fa-vk cursor-pointer" onClick={() => {
                    logEvent(analytics!, 'social_redirect', {
                        service: 'vk'
                    });
                    window.location.href = 'https://vk.com/club194102134';
                }}></i>
                <i className="fa-brands fa-telegram cursor-pointer" onClick={() => {
                    logEvent(analytics!, 'social_redirect', {
                        service: 'telegram'
                    });
                    window.location.href = 'https://t.me/+xv1ihtbMrPE3ZDE6';
                }}></i>
            </div>
            <p onClick={() => navigate('/privacy')} className="underline text-[#01487C] cursor-pointer mt-10">Политика в отношении обработки персональных данных</p>
        </div>
    </div>
}